import classes from "./TextButton.module.css";
import {ReactNode} from "react";

type Props = {
    children?: ReactNode | ReactNode[];

    s?: 'sm' | 'xs';

    /**
     * On button is clicked
     * @author Kacper Faber
     * @since 0.1.9
    */
    onClick?: () => void;
};

/**
 * Nice button with only an icon
 * @author Kacper Faber
 * @since 0.1.9
*/
function TextButton(props: Props) {
    /**
     * Get appropriate size class basic upon size
     * @author Kacper Faber
     * @since 0.1.9
    */
    const getSizeClass = () => {
        const size = props.s ?? 'sm';

        if (size == 'sm') {
            return classes.small;
        }

        else if (size == 'xs') {
            return classes.extraSmall;
        }

        throw new Error('Invalid size, size class is not implemented');
    }

    /**
     * Get root classes
     * @author Kacper Faber
     * @since 0.1.9
    */
    const getClasses = () => {
        return `${classes.root} ${getSizeClass()}`;
    };

    return (
        <div className={getClasses()} onClick={props.onClick}>
            { props.children }
        </div>
    );
}

export default TextButton;